import React from 'react'
import { SeguroEncomenda } from './SeguroEncomenda'

export default class DetalheEncomenda extends React.Component {
  render() {
    if (!this.props.encomenda.exibirDetalhe) {
      return null
    }
    const enc = this.props.encomenda
    return (
      <div className="vx-row-detail">
        <div className="vx-row-detail-title">
          <span className="material-icons">info</span>
          Detalhes da Encomenda
        </div>

        <div className="vx-row-detail-grid">
          <div className="vx-row-detail-item">
            <div className="vx-row-detail-item-label">Cidade origem</div>
            <div className="vx-row-detail-item-value">{enc.cidadeOrigem}</div>
          </div>
          <div className="vx-row-detail-item">
            <div className="vx-row-detail-item-label">Cidade destino</div>
            <div className="vx-row-detail-item-value">{enc.cidadeDestino}</div>
          </div>
          <div className="vx-row-detail-item">
            <div className="vx-row-detail-item-label">Data da partida</div>
            <div className="vx-row-detail-item-value">{enc.dataHoraPartida}</div>
          </div>
          <div className="vx-row-detail-item">
            <div className="vx-row-detail-item-label">Data da chegada</div>
            <div className="vx-row-detail-item-value">{enc.dataHoraChegada}</div>
          </div>
          <div className="vx-row-detail-item">
            <div className="vx-row-detail-item-label">Rota</div>
            <div className="vx-row-detail-item-value">{enc.rotaId}</div>
          </div>
          <div className="vx-row-detail-item">
            <div className="vx-row-detail-item-label">Ponto de embarque</div>
            <div className="vx-row-detail-item-value">{enc.embarque}</div>
          </div>
          <div className="vx-row-detail-item">
            <div className="vx-row-detail-item-label">Forma de pagamento</div>
            <div className="vx-row-detail-item-value">{enc.descricaoFormasPagamento}</div>
          </div>
          <div className="vx-row-detail-item">
            <div className="vx-row-detail-item-label">Tipo de cálculo</div>
            <div className="vx-row-detail-item-value">{enc.descricaoTipoCalculo}</div>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginTop: 12 }}>
          <div className="vx-row-detail-pay">
            <div className="vx-row-detail-pay-title">Remetente</div>
            <div className="vx-row-detail-pay-item">
              <span><strong>Nome:</strong> {enc.remetente.nome}</span>
            </div>
            <div className="vx-row-detail-pay-item">
              <span><strong>E-mail:</strong> {enc.remetente.email}</span>
            </div>
            <div className="vx-row-detail-pay-item">
              <span><strong>Telefone:</strong> {enc.remetente.telefone}</span>
            </div>
            <div className="vx-row-detail-pay-item">
              <span><strong>CPF:</strong> {enc.remetente.cpfCnpj}</span>
            </div>
            <div className="vx-row-detail-pay-item">
              <span>{`${enc.enderecoRemetente.logradouro}, ${enc.enderecoRemetente.numero || 'S/N'}${enc.enderecoRemetente.complemento ? `, ${enc.enderecoRemetente.complemento}` : ''}`}</span>
            </div>
            <div className="vx-row-detail-pay-item">
              <span>{`${enc.enderecoRemetente.bairro} - ${enc.enderecoRemetente.localidade} - ${enc.enderecoRemetente.uf}`}</span>
            </div>
            <div className="vx-row-detail-pay-item">
              <span><strong>CEP:</strong> {enc.enderecoRemetente.cep}</span>
            </div>
          </div>

          <div className="vx-row-detail-pay">
            <div className="vx-row-detail-pay-title">Destinatário</div>
            <div className="vx-row-detail-pay-item">
              <span><strong>Nome:</strong> {enc.destinatario.nome}</span>
            </div>
            <div className="vx-row-detail-pay-item">
              <span><strong>E-mail:</strong> {enc.destinatario.email}</span>
            </div>
            <div className="vx-row-detail-pay-item">
              <span><strong>Telefone:</strong> {enc.destinatario.telefone}</span>
            </div>
            <div className="vx-row-detail-pay-item">
              <span><strong>CPF:</strong> {enc.destinatario.cpfCnpj}</span>
            </div>
            {enc.enderecoDestinatario && (
              <>
                <div className="vx-row-detail-pay-item">
                  <span>{`${enc.enderecoDestinatario.logradouro}, ${enc.enderecoDestinatario.numero || 'S/N'}${enc.enderecoDestinatario.complemento ? `, ${enc.enderecoDestinatario.complemento}` : ''}`}</span>
                </div>
                <div className="vx-row-detail-pay-item">
                  <span>{`${enc.enderecoDestinatario.bairro} - ${enc.enderecoDestinatario.localidade} - ${enc.enderecoDestinatario.uf}`}</span>
                </div>
                <div className="vx-row-detail-pay-item">
                  <span><strong>CEP:</strong> {enc.enderecoDestinatario.cep}</span>
                </div>
              </>
            )}
          </div>
        </div>

        <SeguroEncomenda encomenda={enc} />
      </div>
    )
  }
}
